import React from 'react';
import Helmet from 'react-helmet';
import { FaFilePdfO } from 'react-icons/lib/fa';
import Header from '../components/Header/Header';
import Container from '../components/Container/Container';
import Footer from '../components/Footer/Footer';
import config from '../../config/SiteConfig';

import image from '../../static/pdf/RHarwood_UX_Writing_Fundamentals_Certificate.png'; // Tell Webpack this JS file uses this image

function Image() {
  // Import result is the URL of your image
  return <img src={image} alt="Rachael Harwood. UX Writing Fundamentals Certificate" />;
}

const About = () => (
  <div className="container about-container">
    <Helmet title={`Certifications | ${config.siteTitle}`} />
    <Header>Certifications</Header>
    <Container text>
      <br />
      <a href="/pdf/RHarwood_UX_Writing_Fundamentals_Certificate.pdf" target="_blank" rel="noopener noreferrer">
        <Image />
        <FaFilePdfO /> UX Writing Fundamentals
      </a>
    </Container>
    <Footer />
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/pages/certifications.jsx